import { STATICS } from 'statics'
import { FIREBASE_EVENTS } from 'app-constants'
import { AINotFound } from '../ai-not-found'
import './style.scss'

export function AIMessage({ message, children }) {
  return (
    <div className='ai-message-container'>
      <div className='ai-message'>
        <STATICS.STAR />
        <div className='message'>{message}</div>
      </div>
      <div className='ai-content'>{children}</div>
      <div className='ai-not-found'>
        <AINotFound event={FIREBASE_EVENTS.CLICK_ON_TRY_AGAIN_GIGA_HELP} />
      </div>
    </div>
  )
}
